// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9b7e34f5","186":"fb3b2d67","215":"625aef7d","372":"c8c511b5","377":"62a58c5e","738":"fe19a684","841":"79541a37","851":"8e3ed05a","856":"3bc26e1e"}[chunkId] + ".chunk.js";
};